import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/716-cannabis/components/shop/shop-nav-bar.tsx");
